/*eslint-disable */
import React, { Component } from "react";
import { Table, Icon, Button } from "semantic-ui-react";
import VendorPSLineGSTMappingEdit from "./addVendorPSLineGSTMapping";
import ReadAxios from "../axiosComponent/read";
import DeleteAxios from "../axiosComponent/delete";
import cogoToast from "cogo-toast";
import VendorPSLineGSTMappingDeleteModal from "./vendorPsLineGSTMappingDeleteModal";
import { LABELS, MESSAGES, TITLES } from "./vendorPSLineGSTMapping.constants";
export class VendorPSLineGSTMappingTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      vendorRateChart: [],
      deleteModalOpen: false,
      ratechart: false,
      edit: {},
      deleteId:null
    };
  }

  componentDidMount() {
  }

  setDeafultValue = (masterRoute, deafultValue) => {
    ReadAxios({
      url: `${masterRoute}/${deafultValue}`,
    })
      .then((res) => {
        console.log(res.data.resultSet);
      })
      .catch((err) => console.log(err));
  };

  BranchEditModal = (e, data) => {
    console.log(data);
    if (data.add_mode === 'add') {
      this.setState({
        branchmodal: true,
        editUserInputs: false,
        edit: null,
      })
    } else if (data.add_mode === 'edit') {
      this.setState({
        branchmodal: true,
        editUserInputs: true,
        edit: { ...data.user_items },
      })
    } else {
      this.setState({
        deleteModalOpen: true,
        edit: { ...data.user_items },
      })
    }
  };

  BranchModalClose = () => {
    this.setState({ branchmodal: false });
    window.location.reload();
  };
  openDeleteModal = (e, data) => {
    console.log("yes", data);
    this.setState({ deleteModalOpen: true, deleteId: { ...data.user_items } });
  };
  closeDeleteModal = () => {
    this.setState({ deleteModalOpen: false });
  };

  confirmDelete = async(e, data) => {
    console.log("delete row");
    await DeleteAxios({
      url: `vendorPSLineItemGSTMapping`,
      uniqueId:this.state.deleteId.vendorPSLineItemGSTMappingId
    })
      .then((res) => {
        console.log({res});
        cogoToast.success(MESSAGES.deleteProductGSTSuccess || "Product GST deleted successfully", { position: "top-right", hideAfter: 5 });
        this.closeDeleteModal();
        setTimeout(() => {
          window.location.reload()
        }, 1000);
      })
      .catch((err) => {
        console.log({err});
        cogoToast.error(MESSAGES.deleteProductGSTError || "Unable to delete product GST branch", { position: "top-right" })
        this.closeDeleteModal();
      });
  };

  updatePage = () => {
    this.BranchModalClose();
    window.location.reload();
  };

  render() {
    return (
      <>
        {true && (
          <div>
            <Table stackable size="small" selectable>
              <Table.Header className="w3-small">
                <Table.Row>
                  <Table.HeaderCell colSpan="6" className="p-bold-600">
                    {TITLES.productGST || 'Product GST'}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-600" textAlign="right">
                    <Button
                      type="button"
                      className="w3-button w3-blue w3-small w3-round w3-hover-blue"
                      add_mode="add"
                      onClick={this.BranchEditModal}
                    >
                      <Icon name="plus" /> {'New'}
                    </Button>
                  </Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                  <Table.HeaderCell className="p-bold-500" colSpan="1">
                    {LABELS.productDescription || "Product Description"}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-500">
                    {LABELS.transportMode || "Transport Mode"}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-500">
                    {LABELS.gstPercent || "GST Percent"}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-500">
                    {LABELS.edit || "Edit"}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-500">
                    {LABELS.delete || "Delete"}
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              {this.props.vendorPSLineGSTMappingData && this.props.vendorPSLineGSTMappingData.length > 0 ? (
                this.props.vendorPSLineGSTMappingData.map((object, index) => (
                  <Table.Row key={index}>
                    <Table.Cell className="fixedLength150">{object.psDescription ? object.psDescription : "NA"}</Table.Cell>
                    <Table.Cell className="fixedLength150">{object.transportMode ? object.transportMode : "NA"}</Table.Cell>
                    <Table.Cell>{object.gstPercent ? object.gstPercent : "NA"}</Table.Cell>
                    <Table.Cell><Button user_items={object} type="button" add_mode="edit" onClick={this.BranchEditModal} size="mini" color="green" basic icon> <Icon name="edit" /> </Button> </Table.Cell>
                  <Table.Cell><Button type="button"  user_items={object} add_mode="delete" onClick={this.openDeleteModal} size="mini" color="blue" basic icon> <Icon name="trash" /> </Button></Table.Cell>
                  </Table.Row>
                ))
              ) : (
                <Table.Row>
                  <Table.Cell colSpan="6">{MESSAGES.noRecordsFound || "No Record(s) Found"}</Table.Cell>
                </Table.Row>
              )}
            </Table>
          </div>
        )}
        <VendorPSLineGSTMappingDeleteModal
          mappingId={this.state.deleteId}
          deleteOpen={this.state.deleteModalOpen}
          CloseModal={this.closeDeleteModal}
          ConfirmDeleteRow={this.confirmDelete}
        />
        <VendorPSLineGSTMappingEdit
          vendorId={this.props.vendorId}
          mappingModal={this.state.branchmodal}
          CloseModal={this.BranchModalClose}
          vendor_code={this.props.vendor_code}
          editData={this.state.edit}
          onFormSubmit={this.updatePage}
        />
      </>
    );
  }
}

export default VendorPSLineGSTMappingTable;
 